<div class="embed-video-youtube" [ngClass]="[objectFit]">

  <div class="embed-video-youtube__sizer" [innerHTML]="iframeStr" #mainEl>
  </div>

</div>
